import {
    mapSearchResults,
    setSearchingVariables,
    useLazySearchProductsQuery,
} from "./SearchSlice";
import { JSX, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { MoonLoader } from "react-spinners";
import { ResultCategory } from "./components/ResultCategory";
import { useStringTranslation } from "../../common/hooks/useStringTranslation";

const SearchPageContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { t } = useStringTranslation();

    const [trigger] = useLazySearchProductsQuery();

    const {
        machines,
        accessories,
        old_models,
        resultInputValue,
        resultCount,
        isLoading,
    } = useAppSelector((state) => state.search);

    const [typingTimeout, setTypingTimeout] = useState<
        number | ReturnType<typeof setTimeout>
    >(0);

    const searchHandler = (value: string): void => {
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        if (value && value !== "") {
            setTypingTimeout(
                setTimeout(function () {
                    dispatch(
                        setSearchingVariables({
                            isLoading: true,
                            clearResults: true,
                            resultValue: value,
                        }),
                    );
                    trigger({
                        search: value,
                    }).then((result) => {
                        const { data } = result;
                        if (!data) {
                            dispatch(
                                setSearchingVariables({
                                    isLoading: false,
                                    resultCount: 0,
                                }),
                            );
                            return;
                        }

                        dispatch(mapSearchResults(data));
                        dispatch(
                            setSearchingVariables({
                                isLoading: false,
                                resultCount:
                                    data.machines.length +
                                    data.accessories.length +
                                    data.old_models.length,
                            }),
                        );
                    });
                }, 1000),
            );
        }
    };

    return (
        <div className="p-search">
            <div className="p-search__header">
                <div className="c-searchbar">
                    <form
                        className="c-searchbar__form"
                        onSubmit={(e) => e.preventDefault()}
                    >
                        <input
                            type="search"
                            autoFocus
                            onChange={(e) => {
                                searchHandler(e.target.value);
                            }}
                            placeholder={t(
                                "search-for-machines-accessories-or-parts",
                            )}
                        />
                        <div>
                            <img src="/images/search.svg" alt="search" />
                        </div>
                    </form>
                </div>
            </div>

            {!isLoading ? (
                <div className="p-search__content">
                    <div className="p-search__content__header">
                        <h2>
                            {resultCount} {t("results-for").toLowerCase()}{" "}
                            &apos;<u>{resultInputValue}</u>&apos;
                        </h2>
                    </div>

                    <div className="p-search__content__results-container">
                        <ResultCategory
                            products={machines}
                            category={t("machines")}
                            resultCount={machines.length}
                        />
                        <ResultCategory
                            products={accessories}
                            category={t("accessories")}
                            resultCount={accessories.length}
                        />
                        <ResultCategory
                            products={old_models}
                            category={t("old-models")}
                            resultCount={old_models.length}
                            isOldModel
                        />
                    </div>
                </div>
            ) : (
                <div className={"c-loader"}>
                    <MoonLoader color={"#E52713FF"} />
                </div>
            )}
        </div>
    );
};

export default SearchPageContainer;
